var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "currentColor",
        viewBox: "0 0 256 256",
      },
    },
    [
      _c("rect", { attrs: { width: "256", height: "256", fill: "none" } }),
      _c("line", {
        attrs: {
          x1: "152",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("line", {
        attrs: {
          x1: "152",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("rect", {
        attrs: {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("circle", {
        attrs: {
          cx: "96",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("path", {
        attrs: {
          d: "M64,168c3.55-13.8,17.09-24,32-24s28.46,10.19,32,24",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }